import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  yellowGradientShadow: {
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    display: "flex",
    zIndex: "-1",
    position: "fixed",
    alignItems: "center",
    justifyContent: "center",
    background: "rgb(255,223,0)",
    background:
      "-moz-radial-gradient(circle, rgba(255,223,0,0.4542191876750701) 0%, rgba(255,255,255,1) 59%)",
    background:
      "-webkit-radial-gradient(circle, rgba(255,223,0,0.4542191876750701) 0%, rgba(255,255,255,1) 59%)",
    background:
      "radial-gradient(circle, rgba(255,223,0,0.4542191876750701) 0%, rgba(255,255,255,1) 59%)",
    filter:
      'progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffdf00",endColorstr="#ffffff",GradientType=1)',
    opacity: "0.5",
    filter: "blur(150px)",
    alignItems: "center",
  },
  tabs:{
    borderRadius:"50px",
    background:"#FAFAFA",
    height:"45px",
    "&.MuiPaper-elevation4":{
      boxShadow:"none",
    },
    ["@media (max-width: 650px)"]: {
      height:"40px",
    },
  },
  indicatorTab:{
    minHeight:"35px",
    "& button":{
      height:"45px",
      alignSelf:"center",
    },
    "& .MuiTabs-scroller":{
      height:"45px",
      ["@media (max-width: 650px)"]: {
        height:"40px",
      },
      "& .MuiTabs-flexContainer":{
        height:"45px",
        ["@media (max-width: 650px)"]: {
          height:"40px",
        },
      }
    }
    ,
  "& .MuiTabs-indicator": {
    height:"100%",
    borderRadius:"50px",
      backgroundColor: "#FFDF00",
      color:"black",
      "& > span": {
        maxWidth: 40,
        width: "100%",
        backgroundColor: "white"
      }
  
  }
  },
  tabLabel:{
    textTransform:"capitalize",
    fontFamily: "Mulish",
    fontStyle: "normal",
    // fontWeight: "bold",
    fontSize: "19px",
    lineHeight: "24px",
    /* identical to box height */
    
    textAlign: "center",
    
    /* Wireframe/Blue/Secondary */
    
    color: "#282828",
    height:"45px",
    alignSelf:"center",
    "&.MuiTab-textColorPrimary.Mui-selected":{
      // background: "#FFDF00",
      borderRadius:"50px",
      color:"#282828",
      zIndex:"1",
    },    "&:hover":{
      // backgroundImage:" linear-gradient(rgba(0, 0, 0, 0.1) 0 0)",
      borderRadius:"50px",
        },
        ["@media (max-width: 550px)"]: {
          fontSize:"17px"
        },
  },
  body:{
    // height:"100vh",
    height:"100%"
    // paddingBottom:"50px",
  },
  root: {
    background: "#ffffff",
    boxShadow: "0px 4px 30px rgba(13, 13, 13, 0.1)",
    zIndex: "1",
    position: "absolute",
    overflowY: "auto",
    top: "50%",
    minWidth:"300px",
    left: "50%",
    // minHeight:"60vh",
    transform: "translate(-50%, -38vh)",
    width: "40%",
    maxWidth:"650px",
    bgcolor: "#fff",
    maxWidth:"450px",
    // minWidth:"400px",
    // padding: 20,

    // border: "2px solid #000",
    borderRadius: "30px",
    // boxShadow: 0,
    padding: "30px 42px",
    // "@media (max-height:900px)":{
    //   transform: "translate(-50%, -45%)",
    // },
    ["@media (max-width: 850px)"]: {
      width: "80%",
    },
    ["@media (min-width: 1500px)"]: {
      transform: "translate(-50%, -35vh)",
    },
    ["@media (max-width: 650px)"]: {
      width: "93%",
      padding: "10px 0px",
      // overflowY: "auto",
    },
    ["@media (max-width: 550px)"]: {
      transform: "translate(-50%, -35vh)",
    },
    ["@media (min-width: 1200px)"]: {
      width: "30%",
    },
    ["@media (max-height:550px)"]: {
      transform: "translate(-50%, -20vh)",
    },
  },
  mainContent:{
    "@media (max-width:650px)":{
      padding:"15px",
    }
  },
  downArrow: {
    height: "10px",
    width: "14px",
  },
  mainHeading: {
    paddingBottom: "30px",
    textAlign: "center",
    fontFamily: "Mulish",
    fontStyle: "normal",
    fontWeight: "800",
    fontSize: "28px",
    lineHeight: "35px",
    textShadow: "0px 0px, 0.1px 0.1px, 0.1px 0.1px",

    /* Wireframe/Blue/Secondary */

    color: "#282828",
    "@media (max-width:550px)":{
      paddingBottom:"0px",
      paddingTop:"15px",
      fontSize:"24px"
    }

  },
  //   root: {
  //     backgroundColor: theme.palette.background.paper,
  //     width: 500,
  //   },
}), {index: 1});
